import { Firestore } from '../../config/firebase';
import { doc, getDoc } from 'firebase/firestore';

const clubsDb = () => {
  const findOne = async (clubId) => {
    try {
      const clubRef = doc(Firestore, 'clubs', clubId);
      const docSnap = await getDoc(clubRef);
      
      if (!docSnap.exists()) return {name: 'Club does not exist', id: ''};
      
      const club = docSnap.data();
      club.id = docSnap.id;
      return club;
    } catch (error) {
      console.error(error);
      return {name: 'Club does not exist', id: ''};
    }
  }

  return Object.freeze({
    findOne,
  })
}

const Clubs = clubsDb();

export { Clubs }
